
function loadNotes() {
    var type = $('#notable_type').val();
    // type = type || 'customer';
    var id = $('#'+ type + '_id').val();
    var url = '/adm/'+ type +'/' + id + '/notes';
    $('#' + type + '-notes-content').html('').load(url, function(){
        $('[title]').tooltip();
    }).val();
    var url = '/adm/' + type +'/'+ id +'/notes/create';
    $('#'+ type + '-notes-form').html('').load(url, function(){
        turnOnTooltips();
    }).val();

}


function editNote(id) {
    var type = $('#notable_type').val();
    var url = '/adm/notes/' + id + '/edit';
    $('#' + type + '-notes-form').html('').load(url, function(){
        turnOnTooltips();
    }).val();

}

function updateNote(id) {
    var notableType = $('#notable_type').val();
    var url='/adm/notes/'+ id + '/update';
    var noteText = $('#note_text').val();
    var notableID = $('#' + notableType + '_id').val();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    $.ajax({
        url: url,
        type: 'post',
        data: {
            text: noteText,
            type: notableType,
            notable_id: notableID,
        },
        dataType: 'json',
        success: function (data) {
            ppnotify('alert', {
                'title': 'Success',
                'message': data.msg,
            });

            loadNotes();
        },
        error: function (result) {
            swal('Error','Could not update Note','error')
        }
    });
    loadNotes();
    $('#note_text').val('');

}

function storeNote() {
    var notableType = $('#notable_type').val();
    noteText = $('#note_text').val();
    notableID = $('#' + notableType + '_id').val();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    $.ajax({
        url: '/adm/notes/store',
        type: 'post',
        data: {
            text: noteText,
            type: notableType,
            notable_id: notableID,
        },
        dataType: 'json',
        success: function (data) {
            ppnotify('alert', {
                'title': 'Success',
                'message': 'Note Created.',
            });
            loadNotes();
        },
        error: function (result) {
            // console.log(result.responseText);
            swal('Error','Could not create Note','error')
        }
    });
    $('#note_text').val('');

}

function deleteNote(id) {
    var type = $('#notable_type').val();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
        }
    });

    ppnotify('confirm', {
        title: 'Confirm Note Deletion',
        text: 'Are you sure you want delete this note?',
        type: 'info',
        closeOnConfirm: false,
        closeOnCancel: true,
        callback: function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    url: '/adm/notes/destroy/' + id,
                    type: 'get',
                    data: {
                        id: id,
                    },
                    dataType: 'json',
                    success: function (response) {
                        ppnotify('alert', {
                            'title': 'Success',
                            'message': 'Note Deleted.',
                        });
                        loadNotes();
                    },
                    error: function (result) {
                        ppnotify('alert', {
                            'title': 'Error',
                            'message': 'Could not delete note.',
                        });
                    }
                });

            }
        }
    });
}

